import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/icons/check.svg'
import _imports_1 from '@/assets/icons/check-light-green.svg'


const _hoisted_1 = { class: "flex gap-2.5 md:gap-5 md:items-center" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "w-3 md:w-5 h-3 md:h-5 mt-1.5 md:mt-0"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: "w-3 md:w-5 h-3 md:h-5 mt-1.5 md:mt-0"
}
const _hoisted_4 = { class: "text-sm md:text-base leading-relaxed md:leading-[24px] text-primary-gray" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'checked-bullet',
  props: ["color"],
  setup(__props) {

const props = __props;
const color = computed(() => {
  return props?.color || "dark-green";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (color.value === 'dark-green')
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    (color.value === 'light-green')
      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})